// extracted by mini-css-extract-plugin
module.exports = {"all":"DownloadVideo_all__3UIva","footer":"DownloadVideo_footer__k88uO","link":"DownloadVideo_link__1a1wh"};